module.exports = __webpack_public_path__ + "img/yqfk-bg.fd4dca58.png";